import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button } from '@panel/commons';
import Cookies from 'js-cookie';
import { selectColor } from '@panel/commons/core';
import { getColor } from '@panel/commons/core/themev3';
import { useTranslation } from 'react-i18next';
import Atencion from '@panel/commons/assets/img/atencion.svg';

const IntegratorModal = ({ linkToEdit, redirectToEdit, onClose, device }) => {
  const { t } = useTranslation();
  useEffect(() => {
    const statusPanel = Cookies.get('statusPanel');
    if (!statusPanel) {
      Cookies.set('statusPanel', true, {
        expires: 1
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container data-panel='container-performance-integratorModal' device={device}>
      <Img data-panel='performance-integratorModal-imageAtencion' src={Atencion} />
      <div>
        <h3 data-panel='performance-integratorModal-title'>{t('panel.avisos.integratorModal.title')}</h3>
        <p data-panel='performance-integratorModal-subTitle'>{t('panel.avisos.integratorModal.description')}</p>
      </div>
      {!redirectToEdit ? (
        <Button
          buttonType='solidButton'
          dataPanel='avisos-integrator-edit'
          linkRef={linkToEdit}
          text={t('panel.avisos.integratorModal.CTA')}
        />
      ) : (
        <CustomButton
          onClick={() => {
            redirectToEdit(true);
            if (onClose) {
              onClose();
            }
          }}
          data-panel='performance-integrator-edit-customButton'
        >
          {t('panel.avisos.integratorModal.CTA')}
        </CustomButton>
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 28px;
  box-sizing: border-box;
  height: ${({ device }) => (device !== 'mobile' ? '424px' : '399px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  h3 {
    font-family: Hind;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    white-space: normal;
  }
  p {
    font-family: Hind;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    white-space: normal;
    color: ${selectColor('grayDark')};
  }

  > a {
    height: 40px;
  }
`;

const CustomButton = styled.div`
  font-weight: 700;
  height: 40px;
  line-height: 40px;
  margin-right: 15px;
  outline: 0;
  padding: 0px 12px;
  cursor: pointer;
  color: ${selectColor('white')};
  background-color: ${getColor('primary')};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  :hover {
    background-color: ${getColor('secondary')};
  }
`;

const Img = styled.div`
  background-image: url(${({ src }) => src});
  width: 145px;
  height: 96px;
`;

export default IntegratorModal;
